/**
 * Status taxonomies for the MIPS dashboard.
 *
 * Registered once at app startup (imported from `src/main.tsx`). After this
 * module runs, `<StatusBadge taxonomy="mips-decile" status="d1" />` and
 * `<StatusBadge taxonomy="mips-review-status" status="held" />` work
 * everywhere in the app.
 *
 * Definitions per the handoff §6.4 — do not retune the tone mapping without
 * a product conversation.
 */
import { registerTaxonomy } from "@tensaw/visualization";

registerTaxonomy("mips-decile", {
  d1: { label: "1", tone: "danger" },
  d2: { label: "2", tone: "danger" },
  d3: { label: "3", tone: "danger" },
  d4: { label: "4", tone: "danger" },
  d5: { label: "5", tone: "warning" },
  d6: { label: "6", tone: "warning" },
  d7: { label: "7", tone: "warning" },
  d8: { label: "8", tone: "success" },
  d9: { label: "9", tone: "success" },
  d10: { label: "10", tone: "success" },
  na: { label: "NA", tone: "neutral" },
});

registerTaxonomy("mips-review-status", {
  scheduled: { label: "Scheduled", tone: "info" },
  in_progress: { label: "In progress", tone: "pending" },
  held: { label: "Held", tone: "success" },
  cancelled: { label: "Cancelled", tone: "neutral" },
});
